import { createContext, useContext } from 'react'

type PaymentMethodGateContextValue = {
  isGated: boolean
  isSkipped: boolean
  setIsSkipped: (value: boolean) => void
}

export const PaymentMethodGateContext =
  createContext<PaymentMethodGateContextValue | null>(null)

export const usePaymentMethodGate = () => {
  const context = useContext(PaymentMethodGateContext)
  return context?.isGated ?? false
}
